import React, { memo } from 'react';
import { useStyles } from './styles';

export interface ClearProps {
  onClear: () => void;
}

function Clear({ onClear }: ClearProps) {
  const styles = useStyles();

  return (
    <button className={styles.clear} onClick={onClear}>
      clear
    </button>
  );
}

export default memo(Clear);
